
<template>
  <div :class="'splash-screen ' + this.customClasses ">
    <img src="/svgs/loader.svg" alt="" />
  </div>
</template>

<script>
export default {
  name:"LoaderITem",
  props:["customClasses"]
}
</script>

<style>
.splash-screen{
  position: absolute;
  width: 100%;
  height: 100vh;
  background:#FFFFFF;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.splash-screen img{
  text-align: center;
  width: 80px;
  height: 80px;
  margin:0 auto;
  vertical-align: middle;
}
</style>